module.exports = "../images/C-40-download_2x_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/C-40-download_2x_1.png
// module id = 909
// module chunks = 1